import baseMapProductIds from '../../base/baseMapProductIds'
import useProductSettings from '../../base/baseMapProductSettings'
import baseParameterIds from '../../base/baseParameterIds';

export default () => {
  const PARAM_IDS = baseParameterIds
  const DEFAULT_PRODUCT_SETTINGS = useProductSettings(PARAM_IDS)
  const PRODUCT_IDS = baseMapProductIds
  const newProductSettings = {}

  // Rename Wind Observations
  var windMapSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.WIND]
  windMapSettings.name = 'Wind Map'

  newProductSettings[PRODUCT_IDS.WIND] = windMapSettings

  // Rename Flowviz
  var flowmapSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.FLOWVIZ]
  flowmapSettings.name = 'Flow Map'

  newProductSettings[PRODUCT_IDS.FLOWVIZ] = flowmapSettings

  // Rename Sea Surface Currents
  var seaSurfaceCurrentsSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.SURFACE_CURRENTS]
  seaSurfaceCurrentsSettings.name = 'Sea Surface Currents'

  newProductSettings[PRODUCT_IDS.SURFACE_CURRENTS] = seaSurfaceCurrentsSettings

  // Rename Sea Surface Temps
  var sstSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.SST]
  sstSettings.name = 'Sea Surface Temps'

  newProductSettings[PRODUCT_IDS.SST] = sstSettings

  // Onsite Reports
  var onsiteSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.ONSITE_REPORTS]
  onsiteSettings.name = 'Onsite Reports Map'

  newProductSettings[PRODUCT_IDS.ONSITE_REPORTS] = onsiteSettings

  // Nowcast
  var nowcastSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.NOWCAST]
  nowcastSettings.name = 'Nowcast Map'

  newProductSettings[PRODUCT_IDS.NOWCAST] = nowcastSettings

  // Wind + Gust
  var windGustSettings = DEFAULT_PRODUCT_SETTINGS[PRODUCT_IDS.WIND_GUST]
  windGustSettings.name = 'Wind + Gust Map'

  newProductSettings[PRODUCT_IDS.WIND_GUST] = windGustSettings
  return Object.assign({}, DEFAULT_PRODUCT_SETTINGS, newProductSettings)
}
